import React from 'react'
import PropTypes from 'prop-types'
import { Table, Button, Checkbox, Form, Tabs, message } from 'antd'
import PageContainer from 'layout/default-sidebar-layout/PageContainer'
import slug from 'constants/slug'
import update from 'react-addons-update'
import { autobind } from 'core-decorators'
import Breadcrumb from '../breadcrumb'
import createLanguage, { langPropTypes } from 'hoc/create-lang'
import OrganizationApi from 'api/OrganizationApi'
import defaultObjectWebMenu from 'constants/menu'
import defaultObjectMobileMenu from 'constants/menuMobile'
import {
  get,
  orderBy,
  keys,
  findIndex,
  forEach,
  set,
  isUndefined,
} from 'lodash'
import { ApplicationType } from '../../../constants/type'

const FormItem = Form.Item
const { TabPane } = Tabs

const defaultOrderAction = ['view', 'create', 'edit', 'delete', 'export']

const ActiveTabKey = {
  Web: 'web',
  Mobile: 'mobile',
}

const getDefaultMenus = objMenu =>
  Object.keys(objMenu).map(key => ({ key, ...objMenu[key] }))

const defaultWebMenus = getDefaultMenus(defaultObjectWebMenu)
const defaultMobileMenus = getDefaultMenus(defaultObjectMobileMenu)

const webMenus = orderBy(defaultWebMenus, ['numericalOrder'], ['asc'])
const mobileMenus = orderBy(defaultMobileMenus, ['numericalOrder'], ['asc'])

const paginationOptions = {
  pageSize: 1000,
  hideOnSinglePage: true,
}

@createLanguage
@autobind
export default class OrganizationRole extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: {},
      menuMobile: {},
      loading: false,
      nameOrganization: '',
      activeTabKey: ActiveTabKey.Web,
    }

    this.key = this.props.match.params.key
  }

  async componentWillMount() {
    this.setState({ loading: true })
    const key = this.props.match.params.key
    const res = await OrganizationApi.getOne(key)

    if (res.success) {
      res.data.menu && this.setState({ menu: res.data.menu })
      res.data.menuMobile && this.setState({ menuMobile: res.data.menuMobile })
      res.data.name && this.setState({ nameOrganization: res.data.name })
    }

    this.setState({ loading: false })
  }

  handleChangeRule(event, menuName, actionName) {
    const { activeTabKey } = this.state
    const isTabMenuMobile = activeTabKey === ActiveTabKey.Mobile

    if (isTabMenuMobile) {
      this.setState(
        update(this.state, {
          menuMobile: {
            [menuName]: {
              actions: { [actionName]: { $set: event.target.checked } },
            },
          },
        })
      )
      return 
    }

    this.setState(
      update(this.state, {
        menu: {
          [menuName]: {
            actions: { [actionName]: { $set: event.target.checked } },
          },
        },
      })
    )
  }

  handleChangeMenu(event, menuName) {
    const { menu, menuMobile, activeTabKey } = this.state
    const { checked } = event.target
    const isTabMenuMobile = activeTabKey === ActiveTabKey.Mobile

    if (isTabMenuMobile) {
      this.setState({
        menuMobile: {
          ...menuMobile,
          [menuName]: checked
            ? {
                actions: { view: checked },
                numericalOrder:
                  defaultObjectMobileMenu[menuName].numericalOrder,
                description: defaultObjectMobileMenu[menuName].description,
              }
            : undefined,
        },
      })
      return
    }

    this.setState({
      menu: {
        ...menu,
        [menuName]: checked
          ? {
              actions: { view: checked },
              numericalOrder: defaultObjectWebMenu[menuName].numericalOrder,
              description: defaultObjectWebMenu[menuName].description,
            }
          : undefined,
      },
    })
  }

  async handleSubmit(event) {
    event.preventDefault()

    const { menu, menuMobile, activeTabKey } = this.state

    const isTabMenuMobile = activeTabKey === ActiveTabKey.Mobile

    let data = []

    if (isTabMenuMobile) {
      data = this.getDataUpdateMenu(
        menuMobile,
        mobileMenus,
        defaultObjectMobileMenu
      )
    } else {
      data = this.getDataUpdateMenu(menu, webMenus, defaultObjectWebMenu)
    }

    const applicationType = isTabMenuMobile
      ? ApplicationType.Mobile
      : ApplicationType.Web

    try {
      const updatedMenu = await OrganizationApi.updateMenu(
        this.key,
        data,
        applicationType
      )

      if (updatedMenu) {
        if (updatedMenu.success) {
          message.success('Update Rule Organization success!')
          this.props.history.push(slug.organization.list)
        }

        if (updatedMenu.error) message.error(updatedMenu.message)
      }
    } catch (err) {
      message.error("Can't update organization rule")
    }
  }

  renderActions = (_, record, menu, defaultMenu) => {
    const {
      lang: { t },
    } = this.props

    const actions = get(defaultMenu, [record.key, 'actions'], {})

    const actionsOrganization = get(menu, [record.key, 'actions'], {})

    const otherActions = Object.keys(actions).filter(
      actionName => !defaultOrderAction.includes(actionName)
    )

    return (
      <div style={{ display: 'flex', flexWrap: 'wrap' }} key={record.key}>
        {[...defaultOrderAction, ...otherActions].map((actionName, index) => {
          const key = record.key + '_' + actionName + '_' + index
          if (isUndefined(actions[actionName])) return <div key={key} />
          if (actionName === 'view') return <div key={key} />

          return (
            <div
              key={key}
              style={{
                width: '25%',
                wordBreak: 'initial',
                paddingBottom: '8px',
              }}
            >
              <Checkbox
                key={record.key + '_' + actionName}
                onChange={e => {
                  this.handleChangeRule(e, record.key, actionName)
                }}
                checked={actionsOrganization[actionName]}
                disabled={menu ? !menu[record.key] : true}
              >
                {t(`organization.rule.actions.${actionName}`)}
              </Checkbox>
            </div>
          )
        })}
      </div>
    )
  }

  getDataUpdateMenu(menu, menus, defaultMenus) {
    const defaultMenusKey = keys(defaultMenus)
    const menusKey = keys(menu)

    const data = {}

    forEach(menusKey, menuKey => {
      const index = findIndex(
        defaultMenusKey,
        defaultMenuKey => defaultMenuKey === menuKey
      )

      if (index >= 0 && menu[menuKey]) {
        const findRouteMenu = menus.find(x => x.key === menuKey)

        set(data, menuKey, {
          key: menuKey,
          ...menu[menuKey],
          numericalOrder: findRouteMenu
            ? findRouteMenu.numericalOrder
            : menu[menuKey].numericalOrder,
        })
      }
    })

    return data
  }

  getColumns(menu, defaultMenu) {
    const {
      lang: { t },
    } = this.props

    return [
      {
        width: 80,
        title: t('organization.rule.orderby.label') + ' ',
        render: (_, __, index) => {
          return <strong>{index + 1}</strong>
        },
      },
      {
        width: 400,
        title: t('organization.rule.menu.label'),
        render: (_, record) => (
          <Checkbox
            key={record.key}
            onChange={e => {
              this.handleChangeMenu(e, record.key)
            }}
            checked={menu && menu[record.key] ? true : false}
          >
            {t(`organization.rule.${record.key}.name`)}
          </Checkbox>
        ),
      },
      {
        title: t('organization.rule.action.label'),
        render: (text, record) =>
          this.renderActions(text, record, menu, defaultMenu),
      },
    ]
  }

  handleChangeTab = activeTabKey => {
    this.setState({ activeTabKey })
  }

  render() {
    const {
      lang: { t },
    } = this.props

    const {
      menu,
      loading,
      menuMobile,
      activeTabKey,
      nameOrganization = '',
    } = this.state

    return (
      <Form onSubmit={this.handleSubmit}>
        <PageContainer>
          <Breadcrumb
            items={['list', { id: 'rule', name: nameOrganization }]}
          />

          <Tabs
            activeKey={activeTabKey}
            defaultActiveKey={activeTabKey}
            onChange={this.handleChangeTab}
          >
            <TabPane tab="Web" key={ActiveTabKey.Web}>
              <Table
                rowKey={'key'}
                loading={loading}
                dataSource={webMenus}
                pagination={paginationOptions}
                columns={this.getColumns(menu, defaultObjectWebMenu)}
              />
            </TabPane>

            <TabPane tab="Mobile" key={ActiveTabKey.Mobile}>
              <Table
                rowKey={'key'}
                loading={loading}
                dataSource={mobileMenus}
                pagination={paginationOptions}
                columns={this.getColumns(menuMobile, defaultObjectMobileMenu)}
              />
            </TabPane>
          </Tabs>

          <br />

          <FormItem>
            <Button style={{ width: '100%' }} type="primary" htmlType="submit">
              {t(`addon.save`)}
            </Button>
          </FormItem>
        </PageContainer>
      </Form>
    )
  }
}

OrganizationRole.propTypes = {
  lang: langPropTypes,
  pathImg: PropTypes.string,
  fetchData: PropTypes.func,
  onChangePage: PropTypes.func,
  onDeleteItem: PropTypes.func,
  pagination: PropTypes.object,
  onChangePageSize: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/containers/organization/organization-rule/index.js